import React from 'react';
import logo from '#assets/logo/circular.svg';
import { jsx } from '#i18n';
import { Container } from './Attribution.styles';

export const Attribution = () => (
  <Container>
    <div>
      {jsx('common.attribution', {
        icon: <span className="emoji">❤️</span>,
      })}
    </div>
    <img src={logo} alt="logo" />
  </Container>
);
